import Icon from 'veui/components/Icon'
import { IconChevronRight } from 'dls-icons-vue'

Icon.register('chevron-right', IconChevronRight)
